import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import publicHelpers from 'src/app/helpers/public-helpers';
import { EventListsData, eventListTabs, SortedEventListPublishInstances, EventListInfo, EventListPublishInstance } from 'globals/store/share.event-lists.data';
import { BrandOption, BrandingData } from 'globals/store/publish.data';
import { BrandingWrapperComponent } from '../branding/branding-wrapper.component';
import { BrandingTextBlockComponent } from '../branding/branding-text-block.component';
import { CommonModule } from '@angular/common';
import { PhotoComponent } from '../photo';
import { AddToCalComponent } from '../misc/add-to-cal.component';
import { JoiNavWrapper } from '../wrappers/joi-nav-wrapper.component';
import { EventListInstancesComponent } from './event-list-instances.component';
import { MadeWithJoiComponent } from '../icon/made.with.joi.component';
import { SliderImagesComponent } from '../branding/slider-images.component';

@Component({
    selector: 'event-list',
    templateUrl: './event-list.html',
    styleUrls: ['./event-list.scss'],
    standalone: true,
    imports: [BrandingWrapperComponent, SliderImagesComponent, BrandingTextBlockComponent, CommonModule, PhotoComponent, AddToCalComponent, JoiNavWrapper, EventListInstancesComponent, MadeWithJoiComponent],
})
export class EventListComponent implements OnChanges {
  @Input() fullData: EventListsData
  @Input() configureMode = false
  @Input() eventLists: SortedEventListPublishInstances
  @Input() listInfo: EventListInfo
  @Input() brandingData: BrandingData
  @Input() fromShare = false
  @Input() loading = true
  @Output() editEventThumbnail: EventEmitter<EventListPublishInstance> = new EventEmitter()
  @Output() change: EventEmitter<BrandOption> = new EventEmitter()

  UPCOMING = eventListTabs.future
  PAST = eventListTabs.past
  showTabs = false
  showJoi = false
  defaultTabsMenu = [this.UPCOMING, this.PAST]
  tabsMenu = []
  selectedTab = this.UPCOMING
  helpers = publicHelpers
  

  ngOnChanges() {
    if(this.eventLists.past.length === 0 && !this.listInfo.excludedFieldIds.includes('past')){
      this.listInfo.excludedFieldIds.push('past')
    }else if(this.eventLists.past.length && this.listInfo.excludedFieldIds.includes('past')){
      this.listInfo.excludedFieldIds.splice(this.listInfo.excludedFieldIds.indexOf('past'), 1);
    }
    const excludedIds = this.listInfo ? this.listInfo.excludedFieldIds : null
    this.tabsMenu = this.defaultTabsMenu.filter(t => excludedIds && !excludedIds.includes(t))
    this.showTabs = this.tabsMenu.length > 1;
    if (this.tabsMenu.length < 2) this.selectedTab = this.tabsMenu[0]
    this.showJoi = excludedIds && !excludedIds.includes('madeWithJoi')

  }

  trackByIndex(index) {
    return index
  }
}

